(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('RaceQuestion', RaceQuestion);

    RaceQuestion.$inject = ['$resource'];

    function RaceQuestion ($resource) {
        var resourceUrl =  'api/race-questions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
